import React, {FC} from 'react';

import {Trans} from '../../../../../../libs/shared/helpers/src/internationalization/react';
import {useToggle} from '../../../../../../libs/shared/helpers/src/react/hooks/hookHelpers';
import {Handler} from '../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {ButtonVariantsEnum} from '../../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {OkCancelDialog} from '../../../../../components/common/dialogs/okCancelDialog';
import {useAppDispatch, useAppSelector} from '../../../../../helpers/reduxHelpers';
import {deleteSavedViewAsyncAction} from '../../../../../store/panels/analytics/views/analyticsPanelViewsActions';
import {makeGetSelectedView} from '../../../../../store/panels/analytics/views/analyticsPanelViewsSelectors';
import {AnalyticsSelectedViewId} from '../../../../../store/panels/analytics/views/analyticsPanelViewsState';

/*
 * Props.
 */

interface ReportHeaderSaveViewDialogProps {
  onOkClick: Handler;
  onRequestClose: Handler;
  selectedViewId: AnalyticsSelectedViewId;
}

/*
 * Components.
 */

export const ReportHeaderDeleteViewDialog: FC<ReportHeaderSaveViewDialogProps> = ({
  onOkClick,
  onRequestClose,
  selectedViewId,
}) => {
  const currentSavedView = useAppSelector(makeGetSelectedView(selectedViewId));
  const dispatch = useAppDispatch();

  const [isLoading, toggleIsLoading] = useToggle();

  const deleteView = () => {
    toggleIsLoading();
    dispatch(deleteSavedViewAsyncAction(selectedViewId));

    return onOkClick();
  };

  return (
    <OkCancelDialog
      title={
        <Trans id="saved-view-deleteconfirmation-header">
          Delete &quot;{currentSavedView?.name}&quot; view?
        </Trans>
      }
      okButtonLabel={<Trans id="tag-edit-delete">Delete</Trans>}
      okButtonVariant={ButtonVariantsEnum.DANGER}
      onRequestClose={onRequestClose}
      onOkClick={deleteView}
      isOkDisabled={isLoading}
    >
      <Trans id="saved-view-deleteconfirmation-content">Would you like to delete this view?</Trans>
    </OkCancelDialog>
  );
};
